import React from "react";
import { connect } from "react-redux";
import RealTimeText from "../../components/RealTimeText";
import HangupButton from "../../components/buttons/HangupButton";
import { sendMessage as sendTxt, endCall } from "../../actions/sipActions";
import { unBindLocalStream } from "../../actions/configActions";
import { WebChatLayout } from "../../types";
import AudioVideo from "../../components/AudioVideo";
import ActionTypes from "../../actions/actionTypes";
import RoundButton from "../../components/buttons/RoundButton";

import "./InCall.css";
import DialerView from "../../containers/DialerView";

class InCall extends React.Component {
  inCallAlready = false;

  componentWillUnmount() {
    this.props.unBindLocalStream();
  }

  render() {
    if (this.inCallAlready === false) {
      this.inCallAlready = true;
    }
    const {
      layout,
      text,
      colors,
      font,
      sendTxt,
      isVideoAvailable,
      hangup,
      l10n,
    } = this.props;
    return (
      <div id="kiosk-container">
        <RealTimeText
          isVisible={true}
          layout={layout}
          text={text}
          colors={colors}
          font={font}
          sendTxt={sendTxt}
          kioskmode={true}
        />
        <AudioVideo
          isVisible={true}
          isVideoAvailable={isVideoAvailable}
          direction="remote"
          kioskmode={true}
        />
        <AudioVideo
          isVisible={true}
          isVideoAvailable={isVideoAvailable}
          direction="local"
          kioskmode={true}
        />
        <HangupButton
          text={l10n("common.hangup")}
          onClick={hangup}
          kioskmode={true}
        />
        {this.props.dialpadavailable && (
          <RoundButton
            icon={"dialpad"}
            onClick={this.props.hideDialer}
            text={
              this.props.dialerVisible
                ? l10n("toolbar.hidedialpad")
                : l10n("toolbar.showdialpad")
            }
          />
        )}
        <DialerView />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    font: {
      size: state.setting.user.WEB_TEXT_SIZE,
      family: state.setting.user.WEB_FONT,
    },
    colors: {
      background: state.setting.user.WEB_ONEBOX_TEXT_BACKGROUND_COLOR,
      foreground: state.setting.user.WEB_ONEBOX_TEXT_COLOR,
      in: {
        foreground: state.setting.user.WEB_TEXT_IN_COLOR,
        background: state.setting.user.WEB_TEXTAREA_IN_BACKGROUND,
      },
      out: {
        foreground: state.setting.user.WEB_TEXT_OUT_COLOR,
        background: state.setting.user.WEB_TEXTAREA_OUT_BACKGROUND,
      },
    },
    text: {
      in: state.call.text_in,
      out: state.call.text_out,
      combined: state.call.text_combined,
    },
    layout: WebChatLayout.OVER_UNDER,
    isVideoAvailable: state.call.videoavailable,
    l10n: state.config.text,
    dialerVisible: state.call.dialerVisible,
    dialpadavailable: state.config.mode.dialpad,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    sendTxt: str => {
      return dispatch(sendTxt(str));
    },
    hangup: () => {
      return dispatch(endCall());
    },
    unBindLocalStream: () => {
      return dispatch(unBindLocalStream());
    },
    hideDialer: () => {
      return dispatch({
        type: ActionTypes.CALL_HIDE_DIALER,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InCall);






// WEBPACK FOOTER //
// ./src/kiosk/callStates/InCall.jsx